import saveAs from 'file-saver';
import JSZip from 'jszip';
import { events } from './events';
import { Module } from './framework/module';
import { nextTick } from './utils/next-tick.fn';
import { timerSync } from './utils/timer-sync.fn';
import { timer } from './utils/timer.fn';

export class ZipperModule extends Module {
  private zip: JSZip;
  private generatedZip: Blob;
  private zipFilename = 'images.zip';

  async onInit() {
    events.on('open', () => this.onOpen());
    events.on('add-to-zip', (event) => this.addToZip(event));
    events.on('download-zip', () => this.downloadZip());
    events.on('redownload-zip', () => this.reDownloadZip());
    events.on('generate-zip', () => this.generateZip());
  }

  private onOpen() {
    this.zip = new JSZip();
  }

  private async addToZip({ blob, filename }: { blob: Blob; filename: string }) {
    events.emit('progress-info', {
      text: `Adding ${filename} to ${this.zipFilename}`,
    });

    const start = performance.now();
    await nextTick(() =>
      timerSync('add to zip', () =>
        this.zip.file(filename, blob, { base64: true })
      )
    );
    const end = performance.now();

    events.emit('added-to-zip', { filename, elapsed: end - start });
  }

  private async generateZip() {
    events.emit('progress-info', {
      text: `Getting ${this.zipFilename} ready`,
    });

    const content = await timer('generate zip', () =>
      this.zip.generateAsync({ type: 'blob' })
    );
    this.generatedZip = content;

    events.emit('generated-zip');
  }

  private async downloadZip() {
    nextTick(() => {
      saveAs(this.generatedZip, this.zipFilename);
      events.emit('downloaded-zip', { type: 'zip' });
    });
  }

  private async reDownloadZip() {
    nextTick(() => {
      saveAs(this.generatedZip, this.zipFilename);
    });
  }
}
